import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import ReservationModal from '../../../components/stateful/UnitsTable/columns/Actions/actions/ReservationModal';

const propTypes = {
  facility: PropTypes.shape({
    settings: PropTypes.object.isRequired,
    unitGroup: PropTypes.object.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  reservation: PropTypes.shape({
    charges: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number,
        description: PropTypes.string,
      }),
    ),
    moveInDate: PropTypes.string.isRequired,
    reservationMoveInUrl: PropTypes.string,
    tenant: PropTypes.shape({
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      phoneNumber: PropTypes.string,
    }).isRequired,
    totalDue: PropTypes.number.isRequired,
    unitGroupId: PropTypes.string.isRequired,
  }).isRequired,
  enableMoveInNow: PropTypes.bool.isRequired,
};

const defaultProps = {};

const buildReceipt = reservation => ({
  id: reservation.id,
  dueAtMoveIn: reservation.totalDue,
  invoiceableFees: reservation.charges,
  moveInDate: reservation.moveInDate,
  discountPlans: reservation?.discountPlans,
  tenant: {
    email: reservation.tenant.email,
    firstName: reservation.tenant.firstName,
    lastName: reservation.tenant.lastName,
    phone: reservation.tenant.phoneNumber,
  },
});

// For this experiment, our storEDGE API interaction is in the V2 API, but
// we pull in the <ReservationConfirmation /> component, which is a V1 API
// consumer. This container makes sure the data is in the right shape.
const ReservationConfirmationModal = ({
  facility,
  onClose,
  reservation,
  tier,
  enableMoveInNow,
}) => (
  <ReservationModal
    facility={facility}
    onClose={onClose}
    enableMoveInNow={enableMoveInNow}
    receipt={buildReceipt(reservation)}
    {...facility.unitGroup}
    tier={tier}
  />
);

ReservationConfirmationModal.propTypes = propTypes;
ReservationConfirmationModal.defaultProps = defaultProps;

ReservationConfirmationModal.fragments = {
  facility: gql`
    fragment ReservationConfirmationModalFacility on Facility {
      ...ReservationModalFacility
    }

    ${ReservationModal.fragments.facility}
  `,
  reservation: gql`
    fragment ReservationConfirmationModalReservation on Reservation {
      ...ReservationModalReservation
    }

    ${ReservationModal.fragments.reservation}
  `,
  unitGroup: gql`
    fragment ReservationConfirmationModalUnitGroup on UnitGroup {
      ...ReservationModalUnitGroup
    }

    ${ReservationModal.fragments.unitGroup}
  `,
};

export default ReservationConfirmationModal;
